import PropertyDemo2Container from "../../components/home/propertyDemo2";

const PropertyDemo2 = () => {
  return <PropertyDemo2Container />;
};

export default PropertyDemo2;
